import { call, put, takeEvery } from "redux-saga/effects";
import Constants from "../../Action/Constants";
import { ErrorHandlerSequence } from "../Sequences/ErrorHandlerSequence";
import Http from "../../Http/Http";
import PaymentFactory from "../../Entity/Factories/PaymentFactory";
import { ActionInterface } from "../../Interface/ActionInterface";
import { PaymentInterface } from "../../Entity/Entities/Payment/PaymentInterface";

export default function* paymentUpdateField(action: ActionInterface): any {
  try {
    yield put({
      type: Constants.GLOBAL_PAYMENT_UPDATE_FIELD_CLEAR
    });

    yield put({
      type: Constants.GLOBAL_PAYMENT_UPDATE_FIELD_REQUEST
    });

    const res = yield call(Http.patch, `payment/${action.payload?.paymentId}`, action.payload?.payment);
    const payment: PaymentInterface = PaymentFactory.create(res.data.data);

    yield put({
      type: Constants.GLOBAL_PAYMENT_UPDATE_FIELD_SUCCESS,
      payload: {
        payment: payment
      }
    });

    yield put({
      type: Constants.GLOBAL_PAYMENTS_LIST_OUTDATE_REQUESTS
    })

    yield put({
      type: Constants.GLOBAL_CHARGES_LIST_OUTDATE_REQUESTS
    })

    if (action.hasOwnProperty("onSuccess") === true) {
      action.onSuccess.call(this, payment);
    }
  } catch (err) {
    yield ErrorHandlerSequence(err, action);

    yield put({
      type: Constants.GLOBAL_PAYMENT_UPDATE_FIELD_FAILURE,
      payload: {
        err: err
      }
    });
  }
}

export function* watchPaymentUpdateField() {
  yield takeEvery(Constants.GLOBAL_PAYMENT_UPDATE_FIELD_START, paymentUpdateField);
}
